<template>
  <div>
    <h1>
      {{ $t('message.login.loginQrInstallHead') }}
    </h1>
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-md="12" vs-lg="6" vs-xs="12">
        <div>
          <div class="mt-12 w-full" v-html="$t('message.login.loginQrInstallBodyGoogle')" />
          <div class="my-6 w-full">
            <qrcode-vue
              size="200"
              value="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
            />
          </div>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-md="12" vs-lg="6" vs-xs="12">
        <div>
          <div class="mt-12 w-full" v-html="$t('message.login.loginQrInstallBodyApple')" />
          <div class="my-6 w-full">
            <qrcode-vue
              size="200"
              value="https://apps.apple.com/ru/app/google-authenticator/id388497605"
            />
          </div>
        </div>
      </vs-col>
    </vs-row>
    <div class="text-xl text-warning my-6">
      <vs-button @click="next" type="filled">
        {{ $t('message.login.getAuthButton') }}
      </vs-button>
    </div>
    <a href="https://support.google.com/accounts/answer/1066447?hl=ru&co=GENIE.Platform%3DAndroid">
      {{ $t('message.login.loginQrInstruction') }}
    </a>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'LoginDownloadQr',
  methods: {
    next () {
      this.$emit('downloaded')
    }
  },
  components: {
    QrcodeVue
  }
}
</script>

<style scoped>

</style>
